import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const FAQ = () => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleItem = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      question: "Are you a registered organization in Kenya?",
      answer: "Yes we are a registered organization in Kenya since 2012. We have been licensed by Communication Authority in Kenya (CAK) to operate as a CSP."
    },
    {
      question: "What services do you offer?",
      answer: "We offer a comprehensive range of technology services including web development, mobile app development, cloud solutions, digital marketing, IT consulting, and managed IT services. Our team specializes in creating custom solutions tailored to your business needs."
    },
    {
      question: "Do you have direct connections in all MNOs in Kenya?",
      answer: "Yes, we maintain direct connections with all major Mobile Network Operators (MNOs) in Kenya including Safaricom, Airtel, and Telkom. This enables us to provide seamless integration and reliable service delivery across all networks."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Navigation */}
      

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-400 to-blue-600 py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="relative">
            <img 
              src="/assets/faq3.png" 
              alt="FAQ Hero" 
              className="w-full h-64 object-cover rounded-lg shadow-lg"
            />
            <div className="absolute inset-0 bg-blue-600 bg-opacity-50 rounded-lg"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <h1 className="text-6xl font-bold text-white"></h1>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="space-y-6">
          {faqData.map((item, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
              {/* Question Header */}
              <button
                onClick={() => toggleItem(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <span className="text-blue-600 font-bold text-sm">?</span>
                  </div>
                  <h3 className="text-lg font-semibold text-blue-900">
                    {item.question}
                  </h3>
                </div>
                <div className="ml-4 flex-shrink-0">
                  {expandedItems[index] ? (
                    <Minus className="w-5 h-5 text-blue-600" />
                  ) : (
                    <Plus className="w-5 h-5 text-blue-600" />
                  )}
                </div>
              </button>
              
              {/* Answer Content */}
              {expandedItems[index] && (
                <div className="px-6 pb-4">
                  <div className="ml-12 text-gray-700 leading-relaxed">
                    {item.answer}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-blue-600 text-white py-12">
          <div className="max-w-7xl mx-auto px-6">
            
            {/* Top 3 Columns */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 border-b border-blue-500 pb-10">
              
              {/* About Us */}
              <div className="space-y-3 md:border-r border-white md:pr-6">
                <h3 className="text-lg font-bold mb-2">About Us</h3>
                <ul className="text-sm space-y-2">
                  <li><a href="about" className="hover:text-blue-200">Who we are</a></li>
                  <li><a href="about" className="hover:text-blue-200">News Hub</a></li>
                  <li><a href="about" className="hover:text-blue-200">Our Reach</a></li>
                  
                </ul>
              </div>

              {/* Customer Service */}
              <div className="space-y-3 md:border-r border-white md:px-6">
                <h3 className="text-lg font-bold mb-2">Customer Service</h3>
                <ul className="text-sm space-y-2">
                  <li><a href="contact" className="hover:text-blue-200">Message Us</a></li>
                  
                  <li><a href="contact" className="hover:text-blue-200">Comment/Complaint</a></li>
                </ul>
              </div>

              {/* Join + Payment */}
              <div className="space-y-4 md:pl-6">
                
                <div>
                <h4 className="text-sm font-semibold mb-2">Payment Options</h4>
                <div className="flex space-x-4">
                  <img src="/icons/mpesa2.png" alt="Visa" className="h-12 object-contain" />
                  <img src="/icons/mastercard.png" alt="Mastercard" className="h-6 object-contain" />
                  <img src="/icons/visa.png" alt="Amex" className="h-6 object-contain" />
                </div>
              </div>
              </div>
            </div>

            {/* Contact Icons Section */}
            <div className="flex justify-center mt-8 mb-6">
              <div className="flex items-center space-x-6 bg-green-700 px-8 py-4 rounded-lg shadow-lg">
                <span className="text-sm font-semibold">Get in Touch:</span>
                <a 
                  href="tel:+254722943271" 
                  className="bg-white hover:bg-blue-100 p-3 rounded-full transition-all duration-300 transform hover:scale-110 shadow-md"
                  title="Call us"
                >
                  <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </a>
                <a 
                  href="https://wa.me/254722943271" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-white hover:bg-green-50 p-3 rounded-full transition-all duration-300 transform hover:scale-110 shadow-md"
                  title="WhatsApp us"
                >
                  <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Social Media Section */}
            <div className="flex justify-center">
              <div className="flex space-x-4 border border-white p-3 rounded">
                <a href="https://www.facebook.com/SMSAfrica01?mibextid=wwXIfr&rdid=M64RTVM7l0SsUXbw&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1D45K1gBPv%2F%3Fmibextid%3DwwXIfr#" target="_blank" rel="noopener noreferrer"><img src="/icons/facebook.png" alt="Facebook" className="w-6 h-6" /></a>
                <a href="https://www.linkedin.com/company/infinity-tech-africa/" target="_blank" rel="noopener noreferrer"><img src="/icons/linkedin.png" alt="LinkedIn" className="w-6 h-6" /></a>
                <a href="https://www.instagram.com/smsafrica/profilecard/?igsh=eXgwOHBydWdlZGVi" target="_blank" rel="noopener noreferrer"><img src="/icons/email.png" alt="Email" className="w-6 h-6" /></a>
                <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"><img src="/icons/x logo.png" alt="Twitter" className="w-6 h-6" /></a>
                <a href="https://www.tiktok.com/@infinitytechafrica?_t=ZM-8xr2bhp0ey0&_r=1" target="_blank" rel="noopener noreferrer"><img src="/icons/tiktok logo2.png" alt="YouTube" className="w-6 h-6" /></a>
              </div>
            </div>

            {/* Bottom Footer */}
            <div className="text-center pt-6 mt-6 border-t border-blue-500 text-sm">
              <p>&copy; 2025 Infinity Tech Africa | Privacy Policy | Terms & Conditions Apply</p>
            </div>
          </div>
        </footer>

    </div>
  );
};

export default FAQ;